/**
 * Build a shareable URL for the current page from an ordered list of query
 * params. Falsy values (undefined, null, empty string) are skipped, matching
 * the existing filter-link behavior on the orders and locations pages.
 */
export const buildShareableUrl = (
  params: Array<[string, string | undefined | null]>,
): string => {
  const baseUrl = window.location.origin + window.location.pathname;
  const queryParams = new URLSearchParams();

  params.forEach(([key, value]) => {
    if (value) {
      queryParams.set(key, value);
    }
  });

  return baseUrl + "?" + queryParams.toString();
};
